var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"word",style:({
    left: _vm.wordPosition.left + 'px',
    top: _vm.wordPosition.top + 'px'
  })},[_c('span',[_vm._v(" "+_vm._s(_vm.wordPosition.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }